import type { ITranslated } from '@ilteducation/videos';
import { useLocale } from '@/plugins/translation';

const useLanguageTranslations = () => {
  const { t, l } = useLocale();
  const populateLanguage = <T extends ITranslated>(translated: T): T & { languageTranslation: string } => {
    const engLang = l.languages[translated.languageCode as keyof typeof l.languages] as string;
    return {
      ...translated,
      languageTranslation: engLang ? t(engLang) : '',
    };
  };

  const languageTranslated = <T extends { value?: any; languageTranslation: string }>(
    translated: T,
  ): translated is T & {
    languageTranslated: boolean;
    value: T['value'];
  } => 'value' in translated && translated.value !== undefined && translated.languageTranslation !== '';

  return {
    populateLanguage,
    languageTranslated,
  };
};

export default useLanguageTranslations;
